export const api = {
  Login: 'login',
  Logout: 'logout',
  User: 'user',
  License: 'license',
  updateTheme: 'updatetheme',
  ResetPassword: 'resetPassword',
  ResetPasswordReq: 'resetPasswordReq',
  Facility: 'facility',
  Equipment: 'equipment',
  History: 'history',
  Preference: 'preference',
  Report: 'report',
  GenerateReport: 'generateReport',
  comboType: 'comboTypes',
  testAccessLocation: 'testAccessLocation',
  Model: 'model',
  Countries: 'countries',
  TrackingSystem: 'trackingSystem',
  catSoftwareVersion: 'catSoftwareVersion',
  sortOrder: 'sortOrder',
  trackingSystemContact: 'trackingSystemContact'
};
